var BsubWidget = (function () {
    function BsubWidget() {
        this.attrs = {
            purchaseOptionOneTime: 'data-bsub-purchase-option-one-time',
            sellingPlanGroupId: 'data-bsub-selling-plan-group-id',

            sellingPlanIdInput: 'data-bsub-selling-plan-id-input',

            widget: 'data-bsub-widget',
            sellingPlanOptionsContainer: 'data-bsub-selling-plan-options-container',
            sellingPlanOption: 'data-bsub-selling-plan-option',
            sellingPlansContainer: 'data-bsub-selling-plans-container',
            sellingPlanGroup: 'data-bsub-selling-plan-group',
            sellingPlanGroupInput: 'data-bsub-selling-plan-group-input',
            sellingPlan: 'data-bsub-selling-plan',
            sellingPlanInput: 'data-bsub-selling-plan-input',
            dynamicDiscount: 'data-bsub-dynamic-discount',
            productJson: 'data-bsub-product-json',
            groupDiscountSummary: 'data-bsub-group-discount-summary',
            perDeliveryPrice: 'data-bsub-per-delivery-price',
            cartPopupDetails: 'data-bsub-cart-popup-details',
            cartPageDetails: 'data-bsub-cart-page-details',
            moneyFormat: 'data-bsub-money-format',
            pageTemplate: 'data-bsub-page-template',
            priceBoxPrice: 'data-bsub-price-box-price',
            priceBoxSuffix: 'data-bsub-price-box-suffix',
            priceBoxMeta: 'data-bsub-price-box-meta',
        }

        this.selectors = {
            productForm: 'form[action="/cart/add"]',
            variantIdInput: '[name="id"]',
            variantSelector: ['#shappify-variant-id', '.single-option-selector', 'select[name=id]', 'input[name=id]'],
        };

        // autogenerate selectors from attributes
        Object.entries(this.attrs).forEach(function ([key, value]) {
            this.selectors[key] = `[${value}]`;
        }.bind(this));

        this.classes = {
            hidden: 'bsub__hidden',
        };

        this.products = {};
        this.variants = {};
        this.sellingPlanGroups = {};
        this.pageTemplate = '';
    }

    BsubWidget.prototype = Object.assign({}, BsubWidget.prototype, {
        init: function () {
            this._addSellingPlanListener();
            console.debug('BSUB: Initializing widgets...');
            if (!document.querySelector(this.selectors.widget)) {
                console.debug('BSUB: No widgets detected, skipping initialization.');
                return;
            }
            this._parsePageTemplate();
            this._parseProductJson();
            this._addVariantChangeListener();

            var widgets = document.querySelectorAll(this.selectors.widget);
            widgets.forEach(function (widget) {
                this._renderPrices(widget);
                this._renderGroupDiscountSummary(widget);
            }.bind(this));

            window.addEventListener("pageshow", function () {
                this.syncAllVisuallySelected();
            }.bind(this));

            // ✅ ADD THIS HERE (IMPORTANT)
            document.addEventListener('change', function (e) {
                if (!e.target.matches('[data-bsub-selling-plan-input]')) return;

                var widget = e.target.closest('[data-bsub-widget]');
                if (!widget || !window.BOLD || !window.BOLD.BsubWidget) return;

                setTimeout(function () {
                    window.BOLD.BsubWidget.renderAllPrices
                        ? window.BOLD.BsubWidget.renderAllPrices()
                        : window.BOLD.BsubWidget._renderPrices(widget);
                }, 50);
            });

            console.debug('BSUB: Successfully initialized widgets.');
        },

        /**
         * Set the hidden selling_plan input to the visually selected plan in the widget.
         * The browser caches form state between back and forward navigations, but doesn't emit change events.
        */
        syncAllVisuallySelected: function () {
            var widgets = document.querySelectorAll(this.selectors.widget);
            widgets.forEach(this._syncVisuallySelected.bind(this));
        },

        _syncVisuallySelected: function (widget) {
            var selectedGroupEl = widget.querySelector(`${this.selectors.sellingPlanGroupInput}:checked`);

            if (selectedGroupEl) {
                selectedGroupEl.dispatchEvent(new Event('change'));
            }
        },

        _addVariantChangeListener: function () {
            var selectors = document.querySelectorAll(this.selectors.variantSelector.join())
            selectors.forEach(function (select) {
                if (select) {
                    select.addEventListener('change', function (event) {
                        var productForm = event.target.closest(this.selectors.productForm);
                        var widget = productForm.querySelector(this.selectors.widget);

                        // NOTE: Variant change event needs to propagate to `input[name=id]`, so wait for that to happen...
                        setTimeout(function () {
                            this._renderPrices(widget);
                            this._renderGroupDiscountSummary(widget);
                        }.bind(this), 100)
                    }.bind(this));
                }
            }.bind(this));
        },

        _parsePageTemplate: function () {
            var pageTemplateInputEl = document.querySelector(this.selectors.pageTemplate);
            if (pageTemplateInputEl === null) {
                return;
            }
            this.pageTemplate = pageTemplateInputEl.value;
        },

        _parseProductJson: function () {
            var productJsonElements = document.querySelectorAll(this.selectors.productJson);

            productJsonElements.forEach(function (element) {
                var productJson = JSON.parse(element.innerHTML);
                this.products[element.dataset.bsubProductId] = productJson;

                productJson.selling_plan_groups.forEach(function (sellingPlanGroup) {
                    this.sellingPlanGroups[sellingPlanGroup.id] = sellingPlanGroup;
                }.bind(this));

                productJson.variants.forEach(function (variant) {
                    this.variants[variant.id] = variant;
                }.bind(this));
            }.bind(this));
        },

        renderAllPrices: function () {
            var widgets = document.querySelectorAll(this.selectors.widget);
            widgets.forEach(this._renderPrices.bind(this));
        },

        /**
         * Display "price / delivery" for each plan label.
         * Should run again if variant changes.
         */
        _renderPrices: function (widget) {
            if (!widget) return;

            var variantId = this._getVariantId(widget);
            var variant = this.variants[variantId];

            if (!variant || !variant.selling_plan_allocations) {
                console.warn("No variant or allocations found", variantId);
                return;
            }

            var planEls = widget.querySelectorAll('[data-bsub-selling-plan]');

            planEls.forEach(function (planEl) {

                var planId = String(planEl.dataset.bsubSellingPlanId);

                var allocation = variant.selling_plan_allocations.find(function (a) {
                    return String(a.selling_plan_id) === planId;
                });

                var priceEl = planEl.querySelector('[data-bsub-per-delivery-price]');

                if (!priceEl) return;

                if (!allocation) {
                    priceEl.innerHTML = '';
                    return;
                }

                priceEl.innerHTML = this._formatPrice(allocation.per_delivery_price);

            }.bind(this));

            // Update the top price-box with the currently selected plan's price
            var checkedPlanInput = widget.querySelector('[data-bsub-selling-plan-input]:checked');
            var priceBoxEl = widget.querySelector(this.selectors.priceBoxPrice);

            if (priceBoxEl) {
                if (checkedPlanInput) {
                    var selectedPlanId = String(checkedPlanInput.value);
                    var selectedAllocation = variant.selling_plan_allocations.find(function (a) {
                        return String(a.selling_plan_id) === selectedPlanId;
                    });

                    if (selectedAllocation) {
                        priceBoxEl.innerHTML = this._formatPrice(selectedAllocation.per_delivery_price);
                    }
                } else {
                    // Fallback: use the first available allocation
                    var firstAllocation = variant.selling_plan_allocations[0];
                    if (firstAllocation) {
                        priceBoxEl.innerHTML = this._formatPrice(firstAllocation.per_delivery_price);
                    }
                }
            }
            // Update the AUTOSHIP group header price with the currently selected plan's price
            var checkedPlanInput = widget.querySelector('[data-bsub-selling-plan-input]:checked');
            var groupHeaderPriceEls = widget.querySelectorAll(
                '[data-bsub-selling-plan-group] [data-bsub-per-delivery-price]'
            );

            groupHeaderPriceEls.forEach(function (el) {
                if (checkedPlanInput) {
                    var selectedPlanId = String(checkedPlanInput.value);
                    var selectedAllocation = variant.selling_plan_allocations.find(function (a) {
                        return String(a.selling_plan_id) === selectedPlanId;
                    });
                    if (selectedAllocation) {
                        el.innerHTML = this._formatPrice(selectedAllocation.per_delivery_price);
                    }
                } else {
                    // Fallback: show first available allocation price
                    var firstAllocation = variant.selling_plan_allocations[0];
                    if (firstAllocation) {
                        el.innerHTML = this._formatPrice(firstAllocation.per_delivery_price);
                    }
                }
            }.bind(this));
        },

        renderAllGroupDiscountSummary: function () {
            var widgets = document.querySelectorAll(this.selectors.widget);
            widgets.forEach(this._renderGroupDiscountSummary.bind(this));
        },

        _renderGroupDiscountSummary: function (widget) {
    var productJsonEl = widget.querySelector(this.selectors.productJson);
    if (!productJsonEl) return;

    var productId = productJsonEl.dataset.bsubProductId;
    var product = this.products[productId];

    if (!product || !product.selling_plan_groups) return;

    var groupRadioEls = widget.querySelectorAll(
        this.selectors.sellingPlanGroup
    );

    groupRadioEls.forEach(function (element) {
        var groupId = element.dataset.bsubSellingPlanGroupId;

        var sellingPlanGroup = product.selling_plan_groups.find(function (group) {
            return group.id === groupId;
        });

        if (!sellingPlanGroup || !sellingPlanGroup.selling_plans) return;

        // get highest discount
        var discounts = sellingPlanGroup.selling_plans.map(function (plan) {
            var adj = plan.price_adjustments?.[0];

            if (!adj) return { value: 0, type: '' };

            return {
                value: adj.value,
                type: adj.value_type,
            };
        });

        if (!discounts.length) return;

        var maxDiscount = discounts.reduce(function (a, b) {
            return a.value > b.value ? a : b;
        }, { value: 0 });

        // 👇 ADD THIS RIGHT HERE
        var discountEls = widget.querySelectorAll(this.selectors.dynamicDiscount);

        discountEls.forEach(function (el) {
            el.innerHTML = maxDiscount.value + '%';
        });

        if (!maxDiscount || maxDiscount.value <= 0) return;

        var upTo = discounts.some(function (d) {
            return d.value !== maxDiscount.value;
        });

        var summaryEl = element.querySelector(this.selectors.groupDiscountSummary);

        // ✅ FIX: prevent crash
        if (!summaryEl) return;

        // ✅ DYNAMIC % (THIS IS YOUR 15% OR ANY VALUE FROM SHOPIFY)
        var discountText = '';

        if (upTo) {
            discountText += 'Up to ';
        }

        if (maxDiscount.type === 'percentage') {
            discountText += maxDiscount.value + '% OFF';
        } else {
            discountText += this._formatPrice(maxDiscount.value) + ' OFF';
        }

        summaryEl.innerHTML = '(Save ' + discountText + ')';
    }.bind(this));
},

        handleSellingPlanGroupChange: function (event) {
            var groupRadioEl = event.target;
            var groupId = groupRadioEl.value;
            var widget = groupRadioEl.closest(this.selectors.widget);

            var suffixEl = widget.querySelector(this.selectors.priceBoxSuffix);
            var metaEl = widget.querySelector(this.selectors.priceBoxMeta);

            var plansContainers = widget.querySelectorAll(this.selectors.sellingPlansContainer);

            plansContainers.forEach(function (plansContainer) {
                var plansContainerGroupId = plansContainer.dataset.bsubSellingPlanGroupId;

                if (plansContainerGroupId === groupId && groupRadioEl.checked) {
                    plansContainer.classList.remove(this.classes.hidden);
                } else {
                    plansContainer.classList.add(this.classes.hidden);
                }
            }.bind(this));

            if (groupId === 'once') {
                this._setSellingPlanIdInput(widget, "");

                var variantId = this._getVariantId(widget);
                var variant = this.variants[variantId];
                var priceBoxEl = widget.querySelector(this.selectors.priceBoxPrice);

                if (priceBoxEl && variant) {
                    priceBoxEl.innerHTML = this._formatPrice(variant.price);
                }

                // Hide suffix and meta for ONE-TIME
                if (suffixEl) suffixEl.style.display = 'none';
                if (metaEl) metaEl.style.display = 'none';

                return;
            }

            // AUTOSHIP — restore suffix and meta
            if (suffixEl) {
                suffixEl.style.display = '';
                suffixEl.innerHTML = '/ month with Autoship';
            }
            if (metaEl) metaEl.style.display = '';

            var sellingPlanId = this._getActiveSellingPlanId(widget, groupId);
            this._setSellingPlanIdInput(widget, sellingPlanId);

            setTimeout(function () {
                this._renderPrices(widget);
            }.bind(this), 50);
        },

        handleSellingPlanChange: function (event) {
            var planRadioEl = event.target;
            var widget = planRadioEl.closest(this.selectors.widget);

            this._setSellingPlanIdInput(widget, planRadioEl.value);

            // 🔥 FORCE PRICE UPDATE
            setTimeout(function () {
                this._renderPrices(widget);
            }.bind(this), 50);
        },

        // NOTE: Selling Plan Options not supported in the current version of the widget...
        handleSellingPlanOptionChange: function (event) {
            var widget = event.target.closest(this.selectors.widget);

            var sellingPlanGroupId = event.target.dataset.bsubSellingPlanGroupId;
            var selectedOptions = this._getSellingPlanOptions(widget, sellingPlanGroupId);
            var sellingPlan = this._getSellingPlanFromOptions(sellingPlanGroupId, selectedOptions);
            this._setSellingPlanIdInput(sellingPlan.id);
        },

        _setSellingPlanIdInput: function (widget, sellingPlanId) {
            var sellingPlanIdInput = widget.querySelector(this.selectors.sellingPlanIdInput);
            var variantId = this._getVariantId(widget);

            sellingPlanIdInput.value = sellingPlanId;
            if (/.*(product).*/.test(this.pageTemplate)) {
                this._updateHistoryState(variantId, sellingPlanId);
            }
        },

        _getSellingPlanGroup: function (groupId) {
            if (!this.sellingPlanGroups[groupId]) {
                console.error('BSUB: Selling plan group data not found.');
                return;
            }

            return this.sellingPlanGroups[groupId];
        },

        // NOTE: Selling Plan Options not supported in the current version of the widget...
        _getSellingPlanOptions: function (widget, sellingPlanGroupId) {
            var sellingPlanOptions = widget.querySelectorAll(
                `${this.selectors.sellingPlanOption}[${this.attrs.sellingPlanGroupId}="${sellingPlanGroupId}"]:checked`
            );

            var selectedOptions = [];
            sellingPlanOptions.forEach(function (optionElement) {
                selectedOptions.push({
                    index: optionElement.dataset.bsubOptionIndex,
                    value: optionElement.value,
                });
            });

            return selectedOptions;
        },

        // NOTE: Selling Plan Options not supported in the current version of the widget...
        _getSellingPlanFromOptions: function (groupId, selectedOptions) {
            var sellingPlans = (this._getSellingPlanGroup(groupId)).selling_plans;

            var planFromOptions = sellingPlans.find(function (plan) {
                return selectedOptions.every(function (option) {
                    return plan.options[option.index].value === option.value;
                });
            });

            return planFromOptions;
        },

        _getVariantId: function (widget) {
            // Try multiple ways (robust fix)
            var productForm = widget.closest('form');

            if (!productForm) {
                console.error('BSUB: Could not find product form.');
                return null;
            }

            var variantInput =
                productForm.querySelector('input[name="id"]') ||
                productForm.querySelector('[name="id"]') ||
                document.querySelector('input[name="id"]');

            if (!variantInput) {
                console.error('BSUB: Variant input not found.');
                return null;
            }

            return variantInput.value;
        },
        _addSellingPlanListener: function () {
            document.addEventListener('change', function (event) {
                if (event.target.matches('[data-bsub-selling-plan-input]')) {
                    var widget = event.target.closest('[data-bsub-widget]');
                    if (!widget) return;

                    setTimeout(function () {
                        this._renderPrices(widget);
                        this._renderGroupDiscountSummary(widget);
                    }.bind(this), 50);
                }
            }.bind(this));
        },
        _getActiveSellingPlanId: function (widget, groupId) {
            var activePlanInputEl = widget.querySelector(
                `input[name=bsub-selling-plan-${groupId}]:checked`,
            );

            if (!activePlanInputEl) {
                console.error(`BSUB: Could not find active plan ID for group ${groupId}.`);
            }

            return activePlanInputEl.value;
        },

        _updateHistoryState: function (variantId, sellingPlanId) {
            if (!history.replaceState || !variantId) {
                return;
            }

            var newurl =
                window.location.protocol +
                '//' +
                window.location.host +
                window.location.pathname +
                '?';

            if (sellingPlanId) {
                newurl += 'selling_plan=' + sellingPlanId + '&';
            }

            newurl += 'variant=' + variantId;

            window.history.replaceState({ path: newurl }, '', newurl);
        },

        /**
         * SellingPlanAllocation is the the information of how a selling plan applies to a
         * specific variant.
         */
        _getSellingPlanAllocation(variantId, sellingPlanId) {
            var variant = this.variants[variantId];

            if (!variant) {
                console.error(`BSUB: Could not find variant ID ${variantId}`);
                return null;
            }

            return variant.selling_plan_allocations.find(function (plan) {
                return `${plan.selling_plan_id}` === sellingPlanId;
            });
        },

        _formatPrice(cents, format) {
            var moneyElement = document.querySelector(this.selectors.moneyFormat)
            var moneyFormat = moneyElement ? moneyElement.getAttribute('data-bsub-money-format') : null

            if (typeof cents === 'string') {
                cents = cents.replace('.', '');
            }

            var value = '';
            var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
            var themeMoneyFormat = this._getThemeMoneyFormat();

            var formatString = format || moneyFormat || themeMoneyFormat;

            function formatWithDelimiters(number, precision, thousands, decimal) {
                thousands = thousands || ',';
                decimal = decimal || '.';

                if (isNaN(number) || number === null) {
                    return 0;
                }

                number = (number / 100.0).toFixed(precision);

                var parts = number.split('.');
                var dollarsAmount = parts[0].replace(
                    /(\d)(?=(\d\d\d)+(?!\d))/g,
                    '$1' + thousands
                );
                var centsAmount = parts[1] ? decimal + parts[1] : '';

                return dollarsAmount + centsAmount;
            }

            switch (formatString.match(placeholderRegex)[1]) {
                case 'amount':
                    value = formatWithDelimiters(cents, 2);
                    break;
                case 'amount_no_decimals':
                    value = formatWithDelimiters(cents, 0);
                    break;
                case 'amount_with_comma_separator':
                    value = formatWithDelimiters(cents, 2, '.', ',');
                    break;
                case 'amount_no_decimals_with_comma_separator':
                    value = formatWithDelimiters(cents, 0, '.', ',');
                    break;
                case 'amount_no_decimals_with_space_separator':
                    value = formatWithDelimiters(cents, 0, ' ');
                    break;
                case 'amount_with_apostrophe_separator':
                    value = formatWithDelimiters(cents, 2, "'");
                    break;
            }

            return formatString.replace(placeholderRegex, value);
        },
        

        _getThemeMoneyFormat(){
          if(typeof Shopify !== 'undefined' && typeof Shopify.money_format !== 'undefined'){
            return Shopify.money_format;
          }

          if(typeof theme !== 'undefined'){
            if(typeof theme.moneyFormat !== 'undefined'){
              return theme.moneyFormat;
            }
            if(typeof theme.strings !== 'undefined' && typeof theme.strings.moneyFormat !== 'undefined'){
              return theme.strings.moneyFormat
            }
            if(typeof theme.shop !== 'undefined' && typeof theme.shop.money_format !== 'undefined'){
              return theme.shop.money_format;
            }
          }

          return "${{ amount }}";
        }
    })

    return BsubWidget;
})();

document.addEventListener('DOMContentLoaded', function () {
    window.BOLD = window.BOLD || {};
    window.BOLD.BsubWidget = new BsubWidget();
    window.BOLD.BsubWidget.init();
});
